export let APP_SETTINGS = {
    version: '',
    company: 'RAF Electric'
};
